/**
 * 会员端已迁至独立 Taro 工程 `Football-mobile`（微信小程序 + H5）。
 * 管理端 / 运营端仍使用本 Vite 工程。
 */
export default function MobileHandoffPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center">
      <h1 className="text-lg font-semibold text-slate-900">会员移动端已使用 Taro</h1>
      <p className="max-w-md text-sm leading-relaxed text-slate-600">
        请在仓库根目录进入 <code className="rounded bg-slate-200 px-1">Football-mobile</code>，安装依赖后执行{" "}
        <code className="rounded bg-slate-200 px-1">npm run dev:h5</code>（浏览器）或{" "}
        <code className="rounded bg-slate-200 px-1">npm run dev:weapp</code>（微信开发者工具导入 dist）。
      </p>
      <p className="max-w-md text-xs text-slate-500">
        技术栈：Taro + Webpack5、weapp-tailwindcss（非浏览器直出 Tailwind）、设计宽 750 + rpx，不用 Vite 作为会员端构建工具。
      </p>
      <div className="mt-4 flex flex-wrap justify-center gap-3">
        <a
          className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white no-underline"
          href="/admin/login"
        >
          管理后台
        </a>
        <a
          className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-800 no-underline"
          href="/platform/login"
        >
          运营后台
        </a>
      </div>
    </div>
  );
}
